import type { ToolId } from '@dale/plans';

import { apiPut } from '../client';
import { ToolsResponseSchema, type ToolMap } from '../schemas';

/**
 * Herramientas: the owner turns a tool on or off for the business, or back to
 * the type's default with `null`. Answers every tool's state after the change.
 * A PUT sets a value, so a retry lands on the same state.
 */
export async function setTool(tool: ToolId, enabled: boolean | null): Promise<ToolMap> {
  return (await apiPut(`/v1/business/tools/${encodeURIComponent(tool)}`, ToolsResponseSchema, { enabled })).data.tools;
}
